<div
  class="choice"
  [class.selected]="selected === choice.id"
  [class.disabled]="choice.disabled"
  *ngFor="let choice of choices"
  (click)="onSelect($event, choice)"
>
  {{ choice.text ? choice.text : (choice.textKey | translate) }}
</div>
